var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 4.42871H20V6.42871H18V19.4287C18 19.6939 17.8946 19.9483 17.7071 20.1358C17.5196 20.3234 17.2652 20.4287 17 20.4287H3C2.73478 20.4287 2.48043 20.3234 2.29289 20.1358C2.10536 19.9483 2 19.6939 2 19.4287V6.42871H0V4.42871H5V1.42871C5 1.16349 5.10536 0.90914 5.29289 0.721604C5.48043 0.534068 5.73478 0.428711 6 0.428711H14C14.2652 0.428711 14.5196 0.534068 14.7071 0.721604C14.8946 0.90914 15 1.16349 15 1.42871V4.42871ZM16 6.42871H4V18.4287H16V6.42871ZM7 2.42871V4.42871H13V2.42871H7Z",
    fill: "#0F172A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.06bbafa68de7c7e65ec9dc62855092e0.svg";
export { ForwardRef as ReactComponent };